/* GLLF Market table cards (staff page). Reads the page's [data-tc-data] JSON and /products/<handle>.js.
   Renders 4×6 shelf talkers (one per page, or two per letter sheet) or folded letter tent cards, then prints.
   Writes nothing to the store. Remembers layout and selection in this browser only. */
(function () {
  'use strict';
  var root = document.querySelector('[data-gllf-table-cards]');
  var dataEl = document.querySelector('[data-tc-data]');
  if (!root || !dataEl) return;
  var R = window.GLLFRecipes || {};
  var esc = R.esc || function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return [].slice.call((el || root).querySelectorAll(s)); };
  var KEY = 'gllf-table-cards';
  var saved = {}; try { saved = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { saved = {}; }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify({ layout: layout(), photos: $('[data-tc-photos]').checked, price: $('[data-tc-price]').checked, off: $$('[data-tc-list] input:not(:checked)').map(function (i) { return i.value; }) })); } catch (e) {}
  }
  var SPRIG = '<svg viewBox="0 0 50 70" aria-hidden="true"><path d="M25 68C25 46 25 28 26 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><g fill="currentColor"><ellipse cx="26" cy="8" rx="3" ry="4.5"/><ellipse cx="21.5" cy="15" rx="3" ry="4.2" transform="rotate(-25 21.5 15)"/><ellipse cx="30.5" cy="15" rx="3" ry="4.2" transform="rotate(25 30.5 15)"/><ellipse cx="21" cy="23" rx="3" ry="4.2" transform="rotate(-25 21 23)"/><ellipse cx="31" cy="23" rx="3" ry="4.2" transform="rotate(25 31 23)"/></g></svg>';
  var status = $('[data-tc-status]'), list = $('[data-tc-list]'), preview = $('[data-tc-preview]'), btn = $('[data-tc-print]');
  var products = []; /* {handle, recipes, title, image, url} */

  function layout() { var r = $('input[name="tc-layout"]:checked'); return r ? r.value : 'talker'; }
  function say(t) { if (status) status.textContent = t || ''; }
  function abs(src) { return !src ? '' : src.indexOf('//') === 0 ? 'https:' + src : src; }
  function sized(src, w) { src = abs(src); return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function qrUrl(p) { return (data.origin || location.origin) + '/products/' + p.handle + '?utm_source=farm-stand&utm_medium=table-card#gllf-recipes'; }

  function cardHtml(p, opts) {
    var photo = opts.photos && p.image;
    var recs = (p.recipes || []).slice(0, 3);
    return '<section class="gllf-tcard' + (opts.tent ? ' gllf-tcard--tent' : '') + (photo ? '' : ' gllf-tcard--nophoto') + '">' +
      '<div class="gllf-card__frame"></div>' +
      '<div class="gllf-tcard__in">' +
        (photo ? '<div class="gllf-tcard__photo"><img src="' + esc(sized(p.image, opts.tent ? 900 : 600)) + '" alt=""></div>' : '') +
        '<div class="gllf-tcard__main" data-tc-fit>' +
          '<div class="gllf-tcard__top">' + (data.logo ? '<img class="gllf-tcard__logo" src="' + esc(data.logo) + '" alt="">' : '') +
            '<p class="gllf-tcard__eyebrow">From our farm kitchen</p></div>' +
          '<h2 class="gllf-tcard__name">' + esc(p.title) + '</h2>' +
          (recs.length ? '<p class="gllf-tcard__try">Try it in</p><ul class="gllf-tcard__recipes">' + recs.map(function (r) { return '<li><span class="gllf-tcard__bullet">' + SPRIG + '</span>' + esc(r) + '</li>'; }).join('') + '</ul>' : '') +
          '<div class="gllf-tcard__bottom">' +
            (opts.qr ? '<div class="gllf-tcard__qr">' + opts.qr + '<span>Scan for ' + (recs.length ? 'these recipes and more' : 'recipes') + ', printable cards and our farm&nbsp;story</span></div>' : '') +
            (opts.price ? '<p class="gllf-tcard__price">Price <span></span></p>' : '') +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="gllf-card__foot"><span>' + esc(data.footer || data.shop) + '</span><span>' + esc(data.domain) + '</span></div>' +
    '</section>';
  }

  function pageHtml(sel, mode, opts) {
    var qr = function (p) { return window.qrcode && R.qrSvg ? R.qrSvg(qrUrl(p)) : ''; };
    var one = function (p, tent) { return cardHtml(p, { photos: opts.photos, price: opts.price, tent: tent, qr: qr(p) }); };
    if (mode === 'tent') {
      return sel.map(function (p) {
        return '<div class="gllf-tc-sheet gllf-tc-sheet--tent"><div class="gllf-tc-sheet__half gllf-tc-sheet__half--flip">' + one(p, true) + '</div>' +
          '<div class="gllf-tc-sheet__fold"><span>Fold here</span></div><div class="gllf-tc-sheet__half">' + one(p, true) + '</div></div>';
      }).join('');
    }
    if (mode === 'talker-letter') {
      var out = '';
      for (var i = 0; i < sel.length; i += 2) {
        out += '<div class="gllf-tc-sheet gllf-tc-sheet--talkers">' + one(sel[i], false) + (sel[i + 1] ? one(sel[i + 1], false) : '') + '</div>';
      }
      return out;
    }
    return sel.map(function (p) { return '<div class="gllf-tc-sheet gllf-tc-sheet--card">' + one(p, false) + '</div>'; }).join('');
  }

  function fitCards(box) {
    $$('[data-tc-fit]', box).forEach(function (m) {
      var s = 1; m.style.setProperty('--tc-s', s);
      while ((m.scrollHeight > m.clientHeight + 1 || m.scrollWidth > m.clientWidth + 1) && s > 0.6) { s -= 0.04; m.style.setProperty('--tc-s', s.toFixed(2)); }
    });
  }
  function whenImages(box) {
    return Promise.all($$('img', box).map(function (img) { return img.complete ? null : new Promise(function (r) { img.onload = img.onerror = r; }); }));
  }
  function ready(box) {
    var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    return Promise.all([fonts, whenImages(box)]).then(function () { fitCards(box); return box; });
  }
  function selected() {
    var on = {}; $$('[data-tc-list] input:checked').forEach(function (i) { on[i.value] = 1; });
    return products.filter(function (p) { return on[p.handle]; });
  }
  function opts() { return { photos: $('[data-tc-photos]').checked, price: $('[data-tc-price]').checked }; }

  /* On-screen preview: first selected product in the chosen layout, scaled to fit. */
  var pvTimer;
  function renderPreview() {
    clearTimeout(pvTimer);
    pvTimer = setTimeout(function () {
      var sel = selected();
      if (!preview) return;
      if (!sel.length) { preview.innerHTML = '<p class="gllf-tc__empty">Pick at least one product to see a preview.</p>'; return; }
      var mode = layout();
      var inner = document.createElement('div');
      inner.className = 'gllf-tc__stage';
      inner.innerHTML = pageHtml(sel.slice(0, mode === 'talker-letter' ? 2 : 1), mode, opts());
      preview.innerHTML = '';
      var wrap = document.createElement('div'); wrap.className = 'gllf-tc__scale';
      wrap.appendChild(inner); preview.appendChild(wrap);
      ready(inner).then(function () {
        var sheet = inner.firstElementChild; if (!sheet) return;
        var w = sheet.offsetWidth, h = sheet.offsetHeight, k = Math.min(1, (preview.clientWidth || w) / w);
        inner.style.transform = 'scale(' + k + ')';
        wrap.style.width = Math.round(w * k) + 'px'; wrap.style.height = Math.round(h * k) + 'px';
        var cap = document.createElement('p'); cap.className = 'gllf-tc__cap';
        cap.textContent = 'Preview: ' + (mode === 'tent' ? 'letter sheet, landscape. Fold on the dashed line so both sides face out.' : mode === 'talker-letter' ? 'letter sheet with two 4×6 cards. Cut on the dashed lines.' : '4×6 card, landscape.') + ' ' + sel.length + ' selected.';
        preview.appendChild(cap);
      });
    }, 120);
  }

  var busy = false;
  function print() {
    if (busy) return;
    var sel = selected();
    if (!sel.length) { say('Pick at least one product first.'); return; }
    busy = true; btn.disabled = true; say('Getting ' + sel.length + ' card' + (sel.length === 1 ? '' : 's') + ' ready…');
    var mode = layout();
    var box = document.createElement('div');
    box.className = 'gllf-tc-print gllf-tc-print--' + mode;
    box.style.cssText = 'position:absolute;left:-99999px;top:0';
    document.body.appendChild(box);
    var page = document.createElement('style');
    page.textContent = mode === 'talker' ? '@page{size:6in 4in;margin:0}' : mode === 'tent' ? '@page{size:11in 8.5in;margin:0}' : '@page{size:8.5in 11in;margin:0}';
    document.head.appendChild(page);
    var finish = function () {
      document.body.classList.remove('gllf-printing-tc');
      box.remove(); page.remove(); busy = false; btn.disabled = false;
      window.removeEventListener('afterprint', finish);
    };
    (R.loadQr ? R.loadQr(root.getAttribute('data-qr-src') || undefined).catch(function () {}) : Promise.resolve()).then(function () {
      box.innerHTML = pageHtml(sel, mode, opts());
      box.style.cssText = 'position:absolute;left:-99999px;top:0;display:block';
      return ready(box);
    }).then(function () {
      box.style.cssText = '';
      document.body.classList.add('gllf-printing-tc');
      say(mode === 'talker' ? 'Printing on 4×6 card stock. In the print dialog, pick 4×6 paper and 100% scale.' : mode === 'tent' ? 'Printing on letter paper, landscape, 100% scale. Fold on the dashed line.' : 'Printing on letter paper, 100% scale. Cut on the dashed lines.');
      window.addEventListener('afterprint', finish);
      setTimeout(function () { window.print(); setTimeout(function () { if (busy) finish(); }, 1500); }, 60);
    }).catch(function () { finish(); say('Something went wrong getting the cards ready. Please try again.'); });
  }

  function buildList() {
    var off = {}; (saved.off || []).forEach(function (h) { off[h] = 1; });
    list.innerHTML = products.map(function (p) {
      return '<label class="gllf-tc__prod"><input type="checkbox" value="' + esc(p.handle) + '"' + (off[p.handle] ? '' : ' checked') + '>' +
        (p.image ? '<img src="' + esc(sized(p.image, 80)) + '" alt="" loading="lazy">' : '<i aria-hidden="true"></i>') +
        '<span>' + esc(p.title) + '<small>' + (p.recipes.length ? esc(p.recipes.join(' · ')) : 'No recipes yet') + '</small></span></label>';
    }).join('');
  }

  function load() {
    say('Loading products…');
    var rows = data.products || [];
    return Promise.all(rows.map(function (r) {
      return fetch('/products/' + encodeURIComponent(r.handle) + '.js', { credentials: 'same-origin' }).then(function (x) { return x.ok ? x.json() : null; }).catch(function () { return null; });
    })).then(function (arr) {
      var missing = 0;
      products = [];
      rows.forEach(function (r, i) {
        var p = arr[i];
        if (!p) { missing++; return; }
        products.push({ handle: r.handle, recipes: r.recipes || [], title: p.title, image: p.featured_image || (p.images && p.images[0]) || '', url: p.url });
      });
      products.sort(function (a, b) { return a.title.localeCompare(b.title); });
      buildList();
      say(products.length ? products.length + ' foods with recipes' + (missing ? ' (' + missing + ' not online right now, so skipped)' : '') + '.' : 'No foods with recipes found yet.');
      renderPreview();
    });
  }

  if (saved.layout) { var r = $('input[name="tc-layout"][value="' + saved.layout + '"]'); if (r) r.checked = true; }
  if (typeof saved.photos === 'boolean') $('[data-tc-photos]').checked = saved.photos;
  if (typeof saved.price === 'boolean') $('[data-tc-price]').checked = saved.price;
  root.addEventListener('change', function () { save(); renderPreview(); });
  $('[data-tc-all]').addEventListener('click', function () { $$('[data-tc-list] input').forEach(function (i) { i.checked = true; }); save(); renderPreview(); });
  $('[data-tc-none]').addEventListener('click', function () { $$('[data-tc-list] input').forEach(function (i) { i.checked = false; }); save(); renderPreview(); });
  btn.addEventListener('click', print);
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(renderPreview, 200); });
  (R.loadQr ? R.loadQr(root.getAttribute('data-qr-src') || undefined).catch(function () {}) : Promise.resolve()).then(load);
})();
